function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.878 10.93H1.259a.723.723 0 0 0-.723.724v3.619a.724.724 0 0 0 .723.724h3.619a.724.724 0 0 0 .724-.724v-1.086h2.533a.724.724 0 1 0 0-1.447H5.602v-1.086a.724.724 0 0 0-.724-.723Zm-.724 3.62h-2.17v-2.172h2.17v2.171ZM2.345 6.123V9.12a.724.724 0 0 0 1.447 0V6.124a2.895 2.895 0 1 0-1.447 0Zm.724-4.24a1.447 1.447 0 1 1 0 2.895 1.447 1.447 0 0 1 0-2.895Zm10.855 8.787V8.399a.724.724 0 1 0-1.447 0v2.274a2.895 2.895 0 1 0 1.447 0Zm-.723 4.24a1.447 1.447 0 1 1 0-2.893 1.447 1.447 0 0 1 0 2.893Zm-1.81-9.046h3.62a.724.724 0 0 0 .723-.724V1.522a.724.724 0 0 0-.724-.724h-3.618a.724.724 0 0 0-.724.724v1.086H8.135a.724.724 0 1 0 0 1.447h2.533v1.086a.723.723 0 0 0 .724.724Zm.724-3.62h2.171v2.172h-2.17V2.246Z"
});

function SvgExtraInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraInfo);
export default __webpack_public_path__ + "static/media/extra-info.4b04510c.svg";
export { ForwardRef as ReactComponent };